import { Component, OnInit, OnDestroy, ChangeDetectorRef, Optional, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgControl, AbstractControl } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription, Subject } from 'rxjs';
import { VocabularyService } from "../services/VocabularyService";

import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../vocabulary.module.config';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { ActionBase } from '../../core/store/action/ActionBase';
import { AddCodeSystemModel } from '../models/AddCodeSystemModel';
import { LookupModel } from '../../common/models/LookupModel';
import { Observable } from 'rxjs/Observable';
import { FocusMonitor } from '@angular/cdk/a11y';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';


@Component({
  selector: 'app-add-code-system-dialog',
  templateUrl: './add-code-system-dialog.component.html',
  styleUrls: ['./add-code-system-dialog.component.scss']
})
export class AddCodeSystemDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  stateChanges = new Subject<void>();
  loading: boolean;
  addActionIdentifier: string;
  focused: boolean;
  touched: any = () => {};
  options: LookupModel[];
  filteredOptions: LookupModel[] = [];
  options$: Observable<LookupModel[]>;
  optionsSubject = new Subject<LookupModel[]>();
  ngControl:AbstractControl;


  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<AddCodeSystemDialogComponent>,
    private formBuilder: FormBuilder,
    private router: Router,
    private actions$: Actions,
    private vocabularyService: VocabularyService,
    private focusMonitor: FocusMonitor,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    ) {
    this.addForm = formBuilder.group({
      name: ['',this.validLookup]
    });
    focusMonitor.monitor(elementRef.nativeElement, true).takeUntil(this.destroyed$).subscribe(origin => {
      this.focused = !!origin;
      if (this.focused && this.ngControl && !this.ngControl.touched) {
        this.touched();
        this.updateOptions(this.ngControl.value);
      }
      this.stateChanges.next();
    });
  }

  validLookup(control: AbstractControl) {
    if (control.value == null || control.value.key === null || control.value.key === undefined || control.value.key === "") {
      return { 'validLookup': { value: control.value } };
    }
    return null;
  }

  ngOnInit() {
    this.ngControl = this.addForm.get('name');
    this.options$ = this.optionsSubject.asObservable();
    this.actions$.ofType(actions.addSuccessType<AddCodeSystemModel>(ModuleConfiguration.moduleName, AddCodeSystemModel))
      .takeUntil(this.destroyed$)
      .subscribe((a: actions.AddSuccessAction<AddCodeSystemModel>) => {
        this.router.navigateByUrl('vocabulary-dashboard/' + a.payload.key);
        this.loading = false;
        this.addActionIdentifier = undefined;
        this.close();
      });

    if (this.ngControl) {
      this.ngControl
        .valueChanges
        .takeUntil(this.destroyed$)
        .subscribe(value => {
          this.getPage(value);
        });
    }
    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.addActionIdentifier && a.payload.action.identifier === this.addActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        this.loading = false;
        this.addActionIdentifier = undefined;
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }

      });
    this.getPage('');
  }

  private getPage(term: string) {
    this.vocabularyService.getSubmittingEntitiesWithoutCodeSystem(term)
        .take(1)
        .subscribe(lookups => {
          this.options = lookups;
          if (!this.options || this.options.length === 0) {
            var error = "You do not have access to any other submitting entities that do not already have Vocabulary";
            if (this.alerts.allAlerts.every( a => a.message !== error)) {
              this.alerts.addError(error);
            }
          }
          this.updateOptions(this.ngControl ? this.ngControl.value : '');
        });
  }

  private updateOptions(value: string): void {
    if (this.options) {
      var valid = this.ngControl ? this.ngControl.value : true;
      this.filteredOptions = this.options.filter(l => valid || !value || Object.prototype.toString.call(value) !== "[object String]" || this.displayFn(l).toLowerCase().includes(value.toLowerCase()));
      this.optionsSubject.next(this.filteredOptions);
    }
    this.changeDetectorRef.markForCheck();
  }


  displayFn(lookupModel?: LookupModel): string | undefined {
    if (lookupModel && lookupModel.key) {
      return lookupModel.description;
    }
    return undefined;
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  add() {
    var model = new AddCodeSystemModel();
    model.name = this.addForm.value.name;
    var addAction = new actions.AddAction(ModuleConfiguration.moduleName, AddCodeSystemModel, { model: model });
    this.addActionIdentifier = addAction.identifier;
    this.store.dispatch(addAction);
    this.loading = true;
  }

  close() {
    this.dialogRef.close();
  }

}




// WEBPACK FOOTER //
// ./src/app/vocabulary/components/add-code-system-dialog.component.ts